var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettinggroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.72892,
    cy: 16.2702,
    r: 3.89583,
    transform: "rotate(180 5.72892 16.2702)",
    stroke: "#2177FE",
    strokeWidth: 1.375
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2707,
    cy: 16.2702,
    r: 3.89583,
    transform: "rotate(180 16.2707 16.2702)",
    stroke: "#2177FE",
    strokeWidth: 1.375
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.72892,
    cy: 5.72819,
    r: 3.89583,
    transform: "rotate(180 5.72892 5.72819)",
    stroke: "#2177FE",
    strokeWidth: 1.375
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2707,
    cy: 5.72819,
    r: 3.89583,
    transform: "rotate(180 16.2707 5.72819)",
    stroke: "#2177FE",
    strokeWidth: 1.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettinggroup);
export default __webpack_public_path__ + "static/media/setting group.1f3a944f19796ef172815394eccf4525.svg";
export { ForwardRef as ReactComponent };